import { useState, useEffect,} from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddUser, IUser } from "../../User.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useEditUser = (userId: string) => {
  const [formData, setFormData] = useState<IAddUser>({
    userName: "",
    userCode:"",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [user, setUser] = useState<IUser | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getuser}/${userId}`,
      });
      console.log("response", response);
      setUser(response);
      populateFormData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const populateFormData = (userData: IUser) => {
    setFormData({
      userName: userData.userName,
      userCode: userData.userCode,
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmit: SubmitHandler<IAddUser> = async () => {
    try {
      const response = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateuser}/${userId}`,
        data: formData,
      });

      if (response !== "undefined") {
        toast.success("User updated successfully", {
          duration: 10000, // Set the duration in milliseconds
        });
        // alert("User updated successfully");
        navigate("/user");
        window.location.reload();
      }
    } catch (error) {
      toast.error("Error updating status", {
        duration: 10000, // Set the duration in milliseconds
      });
      console.error("Error updating user:", error);
    }
  };

  const handleCancel = () => {
    window.location.reload();
  };

  return {
    loading,
    formData,
    user,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useEditUser;
